import Icon from 'vue-awesome/components/Icon'

Icon.register({
  done_outline: {
    paths: [
      {
        d: 'M19.77 5.03l1.4 1.4L8.43 19.17l-5.6-5.6 1.4-1.4 4.2 4.2L19.77 5.03m0-2.83L8.43 13.54l-4.2-4.2L0 13.57 8.43 22 24 6.43 19.77 2.2z'
      }
    ],
    width: '24',
    height: '24'
  }
})
